<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.wineForm.list")}}</span>
    <div class="list-container">
      <div v-if="dataLoaded">
        <AveineWineFormList :APIbaseURL="APIbaseURL" :wineForms="wineForms" :adminMode="true"/>
        <div class="text-center">
          <v-pagination
            v-model="currentPage"
            :length="paginationLength"
            :total-visible="paginationLength < 7 ? paginationLength : 7"
          ></v-pagination>
        </div>
      </div>
      <div v-else>
        <div class="d-flex flex-row mb-10 flex-wrap">
          <v-skeleton-loader
            class="ma-4"
            type="article, actions"
            v-for="index in 42" :key="index" 
          ></v-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { AveineWineFormList } from 'aveine-wine'
import { User, WineForm } from 'aveine-toolbox'
import { errorHandler } from 'aveine-toolbox'
export default {
  name: 'Index',
  components: {
    AveineWineFormList
  },
    data () {
    return {
      wineForms: [],
      currentPage: this.$route.query.page ? parseInt(this.$route.query.page) : 1,
      paginationLength: 0,
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  watch: {
    async currentPage (val) {
      this.dataLoaded= false;

      if (this.$route.query.filter) {
        this.$router.push({ path: '/authenticated/wine-forms/list', query: { page: val, filter: this.$route.query.filter }});
      } else {
        this.$router.push({ path: '/authenticated/wine-forms/list', query: { page: val }});
      }

      
    },
  },
  created() {
    this.loadDate();
  },
  methods: {
    async loadDate () {
      try {
        this.wineForms = []
        let wineForms = await WineForm.api().get(`wine-forms?lang=${this.$i18n.locale}`, {
            params: {
              "include": 'scan,region,country,domain,appellation,grapes-composes-wine-form,edited-wine.primary-wine-label',
              "filter[state]": "pending",
              "filter[appellation.name]": this.$route.query.filter ? this.$route.query.filter : undefined,
              "sort": "created-at",
              "page[number]": this.$route.query.page ? this.$route.query.page : 1,
              "page[size]": 40
            }
          }
        );

        wineForms.response.data.map(async (wineForm) => {
          let wineFormToPush = await WineForm.query().whereId(wineForm.id).withAllRecursive().first()
          let completion = 0;

          if (wineFormToPush.color !== undefined)
            completion = completion + 3;

          if (wineFormToPush.vintage !== undefined)
            completion++

          if (wineFormToPush.appellation !== undefined)
            completion = completion + 2;

          if (wineFormToPush.abv !== undefined)
            completion++;

          if (wineFormToPush.grapes_composes_wine_form !== undefined && wineFormToPush.grapes_composes_wine_form.length)
            completion = completion + 2;
          
          if (wineFormToPush.sparkling !== undefined)
            completion++;

          if (wineFormToPush.organic !== undefined)
            completion = completion + 0.5;

          if (wineFormToPush.natural !== undefined)
            completion++;

          if (wineFormToPush.vegan !== undefined)
            completion = completion + 0.5;

          if (wineFormToPush.domain !== null)
            completion = completion + 3;

          if (wineFormToPush.region !== null)
            completion = completion + 2;

          if (wineFormToPush.country !== undefined)
            completion++;

          wineFormToPush.completion = Math.round((completion / 18) * 100);

          if (wineForm.cuvee) {
            wineFormToPush.designation = wineForm.cuvee;
          } else if (wineForm.appellation && wineForm.appellation.name) {
            wineFormToPush.designation = wineForm.appellation.name;
          } else if (wineForm.color) {
            wineFormToPush.designation = this.$t(`aveine-wine.attributes.wineTypes.${wineForm.color}`)
          } else {
            wineFormToPush.designation = "-"
          }

          let userReq = await User.api().get(`users/${wineFormToPush.user_id}?lang=${this.$i18n.locale}`, {
              params: {
                "include": 'profile'
              }
            }
          );
          
          wineFormToPush.user = userReq.entities.user_profiles[0]
          this.wineForms.push(wineFormToPush);
        });

        this.paginationLength = wineForms.response.data.meta.last
        this.dataLoaded = true;
      } catch (errors) {
        this.dataLoaded = true;
        errorHandler(errors, this)
      }
    }
  }
}
</script>
